const HideBioToggle = ({ privacyMode, togglePrivacy }) => {
  return (
    <>
      <div className="mt-4 flex items-center justify-start">
        <div className="text-sm font-medium text-gray-700">Hide My Bio</div>
        <input
          type="checkbox"
          checked={privacyMode}
          onChange={togglePrivacy}
          className="toggle w-[40px] h-[17px] mt-0 ml-0 accent-gray-900"
        />
      </div>
      <p className="text-gray-400 text-sm">
        *Unchecking this box will make your data such as your email address, contact address, date of birth, and other personal data visible to the public on your fan page.
      </p>
    </>
  );
};

export default HideBioToggle;
